import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { contactInfo } from '../data/mockData';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Toggle body scroll
    if (!isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  const menuItems = [
    { name: 'Accueil', path: '/' },
    { name: 'Présentation', path: '/presentation' },
    { name: 'Revitalisation', path: '/revitalisation' },
    { name: 'Pieds & Mains', path: '/pieds-mains' },
    { name: 'Mère & Fille', path: '/mere-fille' },
    { name: 'Femme Enceinte', path: '/femme-enceinte' },
    { name: 'Détente', path: '/detente' },
    { name: 'Beauté du Regard', path: '/beaute-regard' },
    { name: 'Anniversaire', path: '/anniversaire' },
    { name: 'Réservation', path: '/reservation' },
    { name: 'Contact', path: '/contact' },
    { name: 'Admin', path: '/admin' }
  ];

  return (
    <header className="header-main">
      <div className="header-top">
        <div className="container-header">
          <div className="header-contact">
            <a href={`tel:${contactInfo.phoneRaw}`} className="header-contact-item">
              <Phone className="icon-small" />
              <span>{contactInfo.phone}</span>
            </a>
            <a href={`mailto:${contactInfo.email}`} className="header-contact-item">
              <Mail className="icon-small" />
              <span>{contactInfo.email}</span>
            </a>
          </div>
        </div>
      </div>

      <div className="header-main-content">
        <div className="container-header">
          <Link to="/" className="logo-container">
            <div className="logo-text">Meya</div>
            <div className="logo-subtitle">Beauté & Tradition</div>
          </Link>

          <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="nav-link"
                onClick={closeMenu}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <button
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div 
          className="menu-overlay active" 
          onClick={closeMenu}
        />
      )}
    </header>
  );
};

export default Header;
